import { Controller } from '@hotwired/stimulus';
import { hide, show } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = ['linkToArchive'];

  connect() {
    hide(this.linkToArchiveTarget);
    document.body.addEventListener(
      'article-teaser-index:no-more-items',
      this.handleArticleTeaserIndexNoMoreItems.bind(this)
    );
  }

  handleArticleTeaserIndexNoMoreItems() {
    show(this.linkToArchiveTarget);
  }
}
